import { ComponentProps, FC } from 'react';
import { GenericInput } from './GenericInput';

export const InputText: FC<ComponentProps<typeof GenericInput>> = (props) => {
  return <GenericInput {...props} />;
};

InputText.defaultProps = {
  charactersType: 'caracteres',
};
